import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 56,
    seconds: 12
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 md:gap-4 font-space-grotesk text-3xl md:text-5xl font-bold text-primary" data-id="element-470">
      <div className="flex flex-col items-center bg-surface p-3 md:p-4 rounded-xl border border-zinc-800 min-w-[70px] md:min-w-[100px]" data-id="element-471">
        <span data-id="element-472">{pad(timeLeft.hours)}</span>
        <span className="text-[10px] md:text-xs text-zinc-400 font-inter mt-1" data-id="element-473">
          HS
        </span>
      </div>
      <span className="text-zinc-600" data-id="element-474">:</span>
      <div className="flex flex-col items-center bg-surface p-3 md:p-4 rounded-xl border border-zinc-800 min-w-[70px] md:min-w-[100px]" data-id="element-475">
        <span data-id="element-476">{pad(timeLeft.minutes)}</span>
        <span className="text-[10px] md:text-xs text-zinc-400 font-inter mt-1" data-id="element-477">
          MIN
        </span>
      </div>
      <span className="text-zinc-600" data-id="element-478">:</span>
      <div className="flex flex-col items-center bg-surface p-3 md:p-4 rounded-xl border border-zinc-800 min-w-[70px] md:min-w-[100px]" data-id="element-479">
        <span data-id="element-480">{pad(timeLeft.seconds)}</span>
        <span className="text-[10px] md:text-xs text-zinc-400 font-inter mt-1" data-id="element-481">
          SEG
        </span>
      </div>
    </div>;
}